// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"b27b47ea","196":"568f104f","256":"0f7e1604","390":"32145306","414":"86ca5adf","453":"d855a71b","481":"898cc55f","570":"acdfacc6","702":"f5d2c089","833":"a6fcfaf0","837":"c5666bd4","881":"869c7763","908":"a2a200ca","975":"f03cd2fc"}[chunkId] + ".chunk.js";
};